import React from 'react';
import { useTranslation } from 'react-i18next';
import { USER_TYPE } from '@panel/commons/constants';
import { IntegrationInfo, StyledConfirmButton } from './styles';
import { INTEGRATIONS } from '../constants';

const IMOBI_BRASIL_API_ID = 581;

function PostingsIntegrationsVisualizer({ user, integration, onRemove = () => {} }) {
  const { t } = useTranslation();
  return (
    <IntegrationInfo>
      <h3>Integrador atual na sucursal{USER_TYPE.ADMINISTRATOR === user?.userTypeId ? ' selecionada:' : ':'}</h3>
      <div className='info-container'>
        <div className='info-data'>
          <div>
            <strong>Integrador:</strong>
            {` ${integration?.integratorName}`}
          </div>
          <div>
            <strong>Tipo de integração:</strong>
            {` ${integration?.integrationType}`}
          </div>
          <div>
            <strong>
              Sucursal{integration?.integrationType === INTEGRATIONS.API ? ` (Cod. Central de Vendas)` : ``}:
            </strong>
            {` ${integration?.companyId}`}
          </div>
          {INTEGRATIONS.XML === integration?.integrationType && (
            <div>
              <strong>XML:</strong>
              {` ${integration?.url}`}
            </div>
          )}
          {INTEGRATIONS.API === integration?.integrationType && (
            <div className='aditional-info'>
              <div className='aditional-info-item'>
                <em>
                  {t('panel.integrations.commons.form.info.credits')}
                  <a href='/configuracion/administrarTopesSucursales.bum' target='_blank'>
                    Estoque de anúncios
                  </a>
                </em>
              </div>
              {integration?.integratorId === IMOBI_BRASIL_API_ID && (
                <div className='aditional-info-item'>
                  <em>
                    {t('panel.integrations.commons.form.info.imobibrasil')}
                    <a
                      rel='noopener noreferrer'
                      href='https://ajuda.imobibrasil.com.br/central-ajuda/integracao-com-imovelweb/'
                      target='_blank'
                    >
                      tutorial
                    </a>
                  </em>
                </div>
              )}
            </div>
          )}
        </div>

        <div className='info-action'>
          <span>
            <StyledConfirmButton onClick={onRemove} ok>
              Desativar
            </StyledConfirmButton>
          </span>
        </div>
      </div>
    </IntegrationInfo>
  );
}

export { PostingsIntegrationsVisualizer };
